import map from 'array-map'
import find from 'array-find'

export default function (value, list) {
  let rs = map(value, (one, index) => {
    return find(list, item => {
      return item.value === one
    })
  })
  return map(rs, one => {
    return one.name
  }).join(' ').replace('--', '')
}



// WEBPACK FOOTER //
// ./~/.0.1.3@vux/src/filters/value2name.js